import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';

const GreenButton = ({ buttonText, buttonIcon, handleClick, disabled }) => (
  <div className="green-btn">
    <Button
      variant="contained"
      color="primary"
      onClick={handleClick}
      endIcon={buttonIcon}
      disabled={disabled}
    >
      {buttonText}
    </Button>
  </div>
);

GreenButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  buttonIcon: PropTypes.node,
  handleClick: PropTypes.func,
  disabled: PropTypes.bool,
};

GreenButton.defaultProps = {
  disabled: false,
  handleClick: () => {},
  buttonIcon: null,
};

export default GreenButton;
